<mat-sidenav #slider (keydown.escape)="onEscape()" [style.width]="formWidth" [position]="'end'" [disableClose]="false" 
[autoFocus]="false" [mode]="formMode">
<div class="app-sidenav-content">
  <ng-template #sliderContent></ng-template>
</div>
</mat-sidenav>
<button *ngIf="isFormOnHold" style="float: right;" (click)="onHoldForm()" color="warn" class="form-on-hold-icon" mat-mini-fab>
  <span class="icon-chevron-left"></span>
</button>